"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AREA_CODE_LABEL = exports.AREA_CODE_PLACEHOLDER = exports.AREA_CODES = void 0;
var AREA_CODES = [{
  code: '11',
  city: 'AMBA'
}, {
  code: '220',
  city: 'MERLO'
}, {
  code: '221',
  city: 'LA PLATA'
}, {
  code: '223',
  city: 'MAR DEL PLATA'
}, {
  code: '230',
  city: 'PILAR '
}, {
  code: '236',
  city: 'JUNÍN'
}, {
  code: '237',
  city: 'MORENO'
}, {
  code: '249',
  city: 'TANDIL'
}, {
  code: '260',
  city: 'SAN RAFAEL'
}, {
  code: '261',
  city: 'MENDOZA'
}, {
  code: '263',
  city: 'SAN MARTÍN'
}, {
  code: '264',
  city: 'SAN JUAN'
}, {
  code: '266',
  city: 'SAN LUIS'
}, {
  code: '280',
  city: 'TRELEW'
}, {
  code: '291',
  city: 'BAHÍA BLANCA'
}, {
  code: '294',
  city: 'SAN CARLOS DE BARILOCHE'
}, {
  code: '297',
  city: 'COMODORO RIVADAVIA'
}, {
  code: '298',
  city: 'GENERAL ROCA'
}, {
  code: '299',
  city: 'NEUQUÉN'
}, {
  code: '336',
  city: 'SAN NICOLÁS DE LOS ARROYOS '
}, {
  code: '341',
  city: 'ROSARIO '
}, {
  code: '342',
  city: 'SANTA FE'
}, {
  code: '343',
  city: 'PARANÁ'
}, {
  code: '345',
  city: 'CONCORDIA'
}, {
  code: '348',
  city: 'BELÉN DE ESCOBAR '
}, {
  code: '351',
  city: 'CÓRDOBA'
}, {
  code: '353',
  city: 'VILLA MARÍA'
}, {
  code: '358',
  city: 'RÍO CUARTO'
}, {
  code: '362',
  city: 'RESISTENCIA'
}, {
  code: '364',
  city: 'PRESIDENCIA ROQUE SÁENZ PEÑA'
}, {
  code: '370',
  city: 'FORMOSA'
}, {
  code: '376',
  city: 'POSADAS'
}, {
  code: '379',
  city: 'CORRIENTES'
}, {
  code: '380',
  city: 'LA RIOJA'
}, {
  code: '381',
  city: 'SAN MIGUEL DE TUCUMÁN'
}, {
  code: '383',
  city: 'SAN FERNANDO DEL VALLE DE CATAMARCA'
}, {
  code: '385',
  city: 'SANTIAGO DEL ESTERO'
}, {
  code: '387',
  city: 'SALTA'
}, {
  code: '388',
  city: 'SAN SALVADOR DE JUJUY'
}, {
  code: '2202',
  city: 'GONZÁLEZ CATÁN'
}, {
  code: '2221',
  city: 'MAGDALENA '
}, {
  code: '2223',
  city: 'BRANDSEN '
}, {
  code: '2224',
  city: 'GLEW '
}, {
  code: '2225',
  city: 'ALEJANDRO KORN'
}, {
  code: '2226',
  city: 'CAÑUELAS'
}, {
  code: '2227',
  city: 'LOBOS '
}, {
  code: '2229',
  city: 'JUAN MARÍA GUTIÉRREZ '
}, {
  code: '2241',
  city: 'CHASCOMÚS'
}, {
  code: '2242',
  city: 'LEZAMA'
}, {
  code: '2243',
  city: 'GENERAL BELGRANO'
}, {
  code: '2244',
  city: 'LAS FLORES'
}, {
  code: '2245',
  city: 'DOLORES'
}, {
  code: '2246',
  city: 'SANTA TERESITA'
}, {
  code: '2252',
  city: 'SAN CLEMENTE DEL TUYÚ'
}, {
  code: '2254',
  city: 'PINAMAR'
}, {
  code: '2255',
  city: 'VILLA GESELL'
}, {
  code: '2257',
  city: 'MAR DE AJÓ'
}, {
  code: '2261',
  city: 'LOBERÍA'
}, {
  code: '2262',
  city: 'NECOCHEA'
}, {
  code: '2264',
  city: 'NICANOR OLIVERA (EST. LA DULCE)'
}, {
  code: '2265',
  city: 'CORONEL VIDAL'
}, {
  code: '2266',
  city: 'BALCARCE'
}, {
  code: '2267',
  city: 'GENERAL JUAN MADARIAGA'
}, {
  code: '2268',
  city: 'MAIPÚ'
}, {
  code: '2271',
  city: 'SAN MIGUEL DEL MONTE'
}, {
  code: '2272',
  city: 'NAVARRO'
}, {
  code: '2273',
  city: 'CARMEN DE ARECO'
}, {
  code: '2274',
  city: 'CARLOS SPEGAZZINI'
}, {
  code: '2281',
  city: 'AZUL'
}, {
  code: '2283',
  city: 'TAPALQUÉ'
}, {
  code: '2284',
  city: 'OLAVARRÍA'
}, {
  code: '2285',
  city: 'LAPRIDA'
}, {
  code: '2286',
  city: 'GENERAL LA MADRID'
}, {
  code: '2291',
  city: 'MIRAMAR'
}, {
  code: '2292',
  city: 'BENITO JUÁREZ'
}, {
  code: '2296',
  city: 'AYACUCHO'
}, {
  code: '2297',
  city: 'RAUCH'
}, {
  code: '2302',
  city: 'GENERAL PICO'
}, {
  code: '2314',
  city: 'SAN CARLOS DE BOLÍVAR'
}, {
  code: '2316',
  city: 'DAIREAUX'
}, {
  code: '2317',
  city: 'NUEVE DE JULIO'
}, {
  code: '2320',
  city: 'JOSÉ C. PAZ'
}, {
  code: '2323',
  city: 'LUJÁN'
}, {
  code: '2324',
  city: 'MERCEDES'
}, {
  code: '2325',
  city: 'SAN ANDRÉS DE GILES'
}, {
  code: '2326',
  city: 'SAN ANTONIO DE ARECO'
}, {
  code: '2331',
  city: 'REALICÓ'
}, {
  code: '2333',
  city: 'QUEMÚ QUEMÚ'
}, {
  code: '2334',
  city: 'EDUARDO CASTEX'
}, {
  code: '2335',
  city: 'CALEUFÚ'
}, {
  code: '2336',
  city: 'HUINCA RENANCÓ'
}, {
  code: '2337',
  city: 'AMÉRICA'
}, {
  code: '2338',
  city: 'VICTORICA'
}, {
  code: '2342',
  city: 'BRAGADO'
}, {
  code: '2343',
  city: 'NORBERTO DE LA RIESTRA'
}, {
  code: '2344',
  city: 'SALADILLO'
}, {
  code: '2345',
  city: '25 DE MAYO'
}, {
  code: '2346',
  city: 'CHIVILCOY'
}, {
  code: '2352',
  city: 'CHACABUCO'
}, {
  code: '2353',
  city: 'GENERAL ARENALES'
}, {
  code: '2354',
  city: 'VEDIA'
}, {
  code: '2355',
  city: 'LINCOLN'
}, {
  code: '2356',
  city: 'GENERAL PINTO'
}, {
  code: '2357',
  city: 'CARLOS TEJEDOR'
}, {
  code: '2358',
  city: 'LOS TOLDOS'
}, {
  code: '2392',
  city: 'TRENQUE LAUQUEN'
}, {
  code: '2393',
  city: 'SALAZAR'
}, {
  code: '2394',
  city: 'TRES LOMAS'
}, {
  code: '2395',
  city: 'CARLOS CASARES'
}, {
  code: '2396',
  city: 'PEHUAJÓ'
}, {
  code: '2473',
  city: 'COLÓN'
}, {
  code: '2474',
  city: 'SALTO'
}, {
  code: '2475',
  city: 'ROJAS'
}, {
  code: '2477',
  city: 'PERGAMINO'
}, {
  code: '2478',
  city: 'ARRECIFES'
}, {
  code: '2622',
  city: 'TUNUYÁN'
}, {
  code: '2624',
  city: 'USPALLATA'
}, {
  code: '2625',
  city: 'GENERAL ALVEAR'
}, {
  code: '2626',
  city: 'LA PAZ'
}, {
  code: '2646',
  city: 'VILLA SAN AGUSTÍN'
}, {
  code: '2647',
  city: 'SAN JOSÉ DE JÁCHAL'
}, {
  code: '2648',
  city: 'CALINGASTA'
}, {
  code: '2651',
  city: 'SAN FRANCISCO DEL MONTE DE ORO'
}, {
  code: '2652',
  city: 'SAN LUIS'
}, {
  code: '2655',
  city: 'LA TOMA'
}, {
  code: '2656',
  city: 'TILISARAO'
}, {
  code: '2657',
  city: 'VILLA MERCEDES'
}, {
  code: '2658',
  city: 'BUENA ESPERANZA'
}, {
  code: '2901',
  city: 'USHUAIA'
}, {
  code: '2902',
  city: 'RÍO TURBIO'
}, {
  code: '2903',
  city: 'RÍO MAYO'
}, {
  code: '2920',
  city: 'VIEDMA'
}, {
  code: '2921',
  city: 'CORONEL DORREGO'
}, {
  code: '2922',
  city: 'CORONEL PRINGLES'
}, {
  code: '2923',
  city: 'PIGÜÉ'
}, {
  code: '2924',
  city: 'DARREGUEIRA'
}, {
  code: '2925',
  city: 'VILLA IRIS'
}, {
  code: '2926',
  city: 'CORONEL SUÁREZ'
}, {
  code: '2927',
  city: 'MÉDANOS'
}, {
  code: '2928',
  city: 'PEDRO LURO '
}, {
  code: '2929',
  city: 'GUAMINÍ'
}, {
  code: '2931',
  city: 'RÍO COLORADO'
}, {
  code: '2932',
  city: 'PUNTA ALTA'
}, {
  code: '2933',
  city: 'HUANGUELÉN'
}, {
  code: '2934',
  city: 'SAN ANTONIO OESTE'
}, {
  code: '2935',
  city: 'RIVERA'
}, {
  code: '2936',
  city: 'CARHUÉ '
}, {
  code: '2940',
  city: 'INGENIERO JACOBACCI'
}, {
  code: '2942',
  city: 'ZAPALA'
}, {
  code: '2945',
  city: 'ESQUEL'
}, {
  code: '2946',
  city: 'CHOELE CHOEL'
}, {
  code: '2948',
  city: 'CHOS MALAL'
}, {
  code: '2952',
  city: 'GENERAL ACHA'
}, {
  code: '2953',
  city: 'MACACHÍN'
}, {
  code: '2954',
  city: 'SANTA ROSA'
}, {
  code: '2962',
  city: 'PUERTO SAN JULIÁN'
}, {
  code: '2963',
  city: 'PERITO MORENO'
}, {
  code: '2964',
  city: 'RÍO GRANDE'
}, {
  code: '2966',
  city: 'RÍO GALLEGOS'
}, {
  code: '2972',
  city: 'SAN MARTÍN DE LOS ANDES'
}, {
  code: '2982',
  city: 'ORENSE'
}, {
  code: '2983',
  city: 'TRES ARROYOS'
}, {
  code: '3327',
  city: 'BENAVÍDEZ'
}, {
  code: '3329',
  city: 'SAN PEDRO'
}, {
  code: '3382',
  city: 'RUFINO'
}, {
  code: '3385',
  city: 'LABOULAYE'
}, {
  code: '3387',
  city: 'BUCHARDO'
}, {
  code: '3388',
  city: 'GENERAL VILLEGAS'
}, {
  code: '3400',
  city: 'VILLA CONSTITUCIÓN'
}, {
  code: '3401',
  city: 'EL TRÉBOL'
}, {
  code: '3402',
  city: 'ARROYO SECO'
}, {
  code: '3404',
  city: 'SAN CARLOS CENTRO'
}, {
  code: '3405',
  city: 'SAN JAVIER'
}, {
  code: '3406',
  city: 'SAN JORGE'
}, {
  code: '3407',
  city: 'RAMALLO'
}, {
  code: '3408',
  city: 'SAN CRISTÓBAL'
}, {
  code: '3409',
  city: 'MOISÉS VILLE'
}, {
  code: '3435',
  city: 'NOGOYÁ'
}, {
  code: '3436',
  city: 'VICTORIA'
}, {
  code: '3437',
  city: 'LA PAZ'
}, {
  code: '3438',
  city: 'BOVRIL'
}, {
  code: '3442',
  city: 'CONCEPCIÓN DEL URUGUAY'
}, {
  code: '3444',
  city: 'GUALEGUAY'
}, {
  code: '3445',
  city: 'ROSARIO DEL TALA'
}, {
  code: '3446',
  city: 'GUALEGUAYCHÚ'
}, {
  code: '3447',
  city: 'COLÓN'
}, {
  code: '3454',
  city: 'FEDERAL'
}, {
  code: '3455',
  city: 'VILLAGUAY'
}, {
  code: '3456',
  city: 'CHAJARÍ'
}, {
  code: '3458',
  city: 'SAN JOSÉ DE FELICIANO'
}, {
  code: '3460',
  city: 'SANTA TERESA '
}, {
  code: '3462',
  city: 'VENADO TUERTO'
}, {
  code: '3463',
  city: 'CANALS'
}, {
  code: '3464',
  city: 'CASILDA'
}, {
  code: '3465',
  city: 'FIRMAT'
}, {
  code: '3466',
  city: 'BARRANCAS'
}, {
  code: '3467',
  city: 'CRUZ ALTA'
}, {
  code: '3468',
  city: 'CORRAL DE BUSTOS'
}, {
  code: '3469',
  city: 'ACEBAL'
}, {
  code: '3471',
  city: 'CAÑADA DE GÓMEZ'
}, {
  code: '3472',
  city: 'MARCOS JUÁREZ'
}, {
  code: '3476',
  city: 'SAN LORENZO'
}, {
  code: '3482',
  city: 'RECONQUISTA'
}, {
  code: '3483',
  city: 'VERA'
}, {
  code: '3487',
  city: 'ZÁRATE'
}, {
  code: '3489',
  city: 'CAMPANA'
}, {
  code: '3491',
  city: 'CERES'
}, {
  code: '3492',
  city: 'RAFAELA'
}, {
  code: '3493',
  city: 'SUNCHALES'
}, {
  code: '3496',
  city: 'ESPERANZA'
}, {
  code: '3497',
  city: 'LLAMBI CAMPBELL'
}, {
  code: '3498',
  city: 'SAN JUSTO'
}, {
  code: '3521',
  city: 'DEÁN FUNES '
}, {
  code: '3522',
  city: 'VILLA DE MARÍA'
}, {
  code: '3524',
  city: 'VILLA DEL TOTORAL'
}, {
  code: '3525',
  city: 'JESÚS MARÍA'
}, {
  code: '3532',
  city: 'OLIVA'
}, {
  code: '3533',
  city: 'LAS VARILLAS'
}, {
  code: '3537',
  city: 'BELL VILLE'
}, {
  code: '3541',
  city: 'VILLA CARLOS PAZ'
}, {
  code: '3542',
  city: 'SALSACATE'
}, {
  code: '3543',
  city: 'CÓRDOBA (ARGÜELLO)'
}, {
  code: '3544',
  city: 'VILLA DOLORES'
}, {
  code: '3546',
  city: 'SANTA ROSA DE CALAMUCHITA'
}, {
  code: '3547',
  city: 'ALTA GRACIA'
}, {
  code: '3548',
  city: 'LA FALDA'
}, {
  code: '3549',
  city: 'CRUZ DEL EJE'
}, {
  code: '3562',
  city: 'MORTEROS'
}, {
  code: '3563',
  city: 'BALNEARIA'
}, {
  code: '3564',
  city: 'SAN FRANCISCO'
}, {
  code: '3571',
  city: 'RÍO TERCERO'
}, {
  code: '3572',
  city: 'RÍO SEGUNDO'
}, {
  code: '3573',
  city: 'VILLA DEL ROSARIO'
}, {
  code: '3574',
  city: 'RÍO PRIMERO'
}, {
  code: '3575',
  city: 'LA PUERTA'
}, {
  code: '3576',
  city: 'ARROYITO'
}, {
  code: '3582',
  city: 'SAMPACHO'
}, {
  code: '3583',
  city: 'VICUÑA MACKENNA'
}, {
  code: '3584',
  city: 'LA CARLOTA'
}, {
  code: '3585',
  city: 'ADELIA MARÍA'
}, {
  code: '3711',
  city: 'INGENIERO JUÁREZ'
}, {
  code: '3715',
  city: 'LAS LOMITAS'
}, {
  code: '3716',
  city: 'COMANDANTE FONTANA'
}, {
  code: '3718',
  city: 'CLORINDA'
}, {
  code: '3721',
  city: 'CHARADAI'
}, {
  code: '3725',
  city: 'GENERAL JOSÉ DE SAN MARTÍN'
}, {
  code: '3731',
  city: 'CHARATA '
}, {
  code: '3734',
  city: 'PRESIDENCIA DE LA PLAZA'
}, {
  code: '3735',
  city: 'VILLA ÁNGELA'
}, {
  code: '3741',
  city: 'BERNARDO DE IRIGOYEN'
}, {
  code: '3743',
  city: 'PUERTO RICO'
}, {
  code: '3751',
  city: 'ELDORADO'
}, {
  code: '3754',
  city: 'LEANDRO N. ALEM'
}, {
  code: '3755',
  city: 'OBERÁ'
}, {
  code: '3756',
  city: 'SANTO TOMÉ'
}, {
  code: '3757',
  city: 'PUERTO IGUAZÚ'
}, {
  code: '3758',
  city: 'APÓSTOLES'
}, {
  code: '3772',
  city: 'PASO DE LOS LIBRES'
}, {
  code: '3773',
  city: 'MERCEDES'
}, {
  code: '3774',
  city: 'CURUZÚ CUATIÁ'
}, {
  code: '3775',
  city: 'MONTE CASEROS'
}, {
  code: '3777',
  city: 'GOYA'
}, {
  code: '3781',
  city: 'CAÁ CATÍ'
}, {
  code: '3782',
  city: 'SALADAS'
}, {
  code: '3786',
  city: 'ITUZAINGÓ'
}, {
  code: '3821',
  city: 'CHEPES'
}, {
  code: '3825',
  city: 'CHILECITO'
}, {
  code: '3826',
  city: 'CHAMICAL'
}, {
  code: '3827',
  city: 'AIMOGASTA'
}, {
  code: '3832',
  city: 'RECREO'
}, {
  code: '3835',
  city: 'ANDALGALÁ'
}, {
  code: '3837',
  city: 'TINOGASTA '
}, {
  code: '3838',
  city: 'SANTA MARÍA'
}, {
  code: '3841',
  city: 'MONTE QUEMADO'
}, {
  code: '3843',
  city: 'QUIMILÍ'
}, {
  code: '3844',
  city: 'AÑATUYA'
}, {
  code: '3845',
  city: 'LORETO'
}, {
  code: '3846',
  city: 'TINTINA'
}, {
  code: '3854',
  city: 'FRÍAS'
}, {
  code: '3855',
  city: 'SUNCHO CORRAL'
}, {
  code: '3856',
  city: 'VILLA OJO DE AGUA'
}, {
  code: '3857',
  city: 'BANDERA'
}, {
  code: '3858',
  city: 'TERMAS DE RÍO HONDO'
}, {
  code: '3861',
  city: 'NUEVA ESPERANZA'
}, {
  code: '3862',
  city: 'TRANCAS'
}, {
  code: '3863',
  city: 'MONTEROS'
}, {
  code: '3865',
  city: 'CONCEPCIÓN'
}, {
  code: '3867',
  city: 'TAFÍ DEL VALLE'
}, {
  code: '3868',
  city: 'CAFAYATE'
}, {
  code: '3869',
  city: 'RANCHILLOS Y SAN MIGUEL '
}, {
  code: '3873',
  city: 'TARTAGAL'
}, {
  code: '3876',
  city: 'SAN JOSÉ DE METÁN'
}, {
  code: '3877',
  city: 'JOAQUÍN VÍCTOR GONZÁLEZ'
}, {
  code: '3878',
  city: 'ORÁN'
}, {
  code: '3885',
  city: 'LA QUIACA'
}, {
  code: '3886',
  city: 'LIBERTADOR GENERAL SAN MARTÍN'
}, {
  code: '3887',
  city: 'HUMAHUACA'
}, {
  code: '3888',
  city: 'SAN PEDRO DE JUJUY'
}, {
  code: '3891',
  city: 'GRANEROS'
}, {
  code: '3892',
  city: 'AMAICHA DEL VALLE'
}, {
  code: '3894',
  city: 'BURRUYACÚ'
}];
exports.AREA_CODES = AREA_CODES;
var AREA_CODE_PLACEHOLDER = 'Sin 0';
exports.AREA_CODE_PLACEHOLDER = AREA_CODE_PLACEHOLDER;
var AREA_CODE_LABEL = 'Cod. área';
exports.AREA_CODE_LABEL = AREA_CODE_LABEL;